<template>
    <div class="container">
        <menu-list></menu-list>
        <div class="main">
            <div class="main-content">
                <div class="main-left ">
                    <div class="product-wrap boxshadow2">
                        <div class="item">
                            <div class="product-img">
                                <img :src="productDefault.image" alt="">
                            </div>
                            <div class="product-attached">
                            <span v-for="(item,index) in productDefault.attachments" :key="`attached_${index}`">
                                <img v-if="index<6" :src="item" alt="" width="44px" height="44px">
                            </span>
                            </div>
                            <div class="product-price">
                                <span>${{productDefault.price}}</span>
                            </div>
                            <div class="product-title" :title="productDefault.title">
                                {{productDefault.title}}
                            </div>
                            <div class="product-comments">
                                <span>9888+ </span> comments
                            </div>
                            <div class="product-shop">
                                <span>
                                    {{productDefault.brand}}
                                    <i class="iconfont iconownbrand"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="main-right">
                    <div class="basics-section boxshadow2">
                        <div class="basics-section-main">
                            <div class="head">
                                <span class="head-1">物流设置</span>
                                <span class="head-2">Logistics Setting</span>
                            </div>
                            <div class="cont">
                                <el-form :inline="true" ref="logisticsForm" :model="product" label-width="220px" size="big" :rules="logisticsRules"
                                         class="edit-product">
                                    <el-form-item label="Declare Name" prop="declareName">
                                        <template slot="label">
                                            <span>Declare Name</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('DeclareName')"></i>
                                        </template>
                                        <el-input v-model="product.declareName"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Declare Local Name"  prop="declareLocalName">
                                        <template slot="label">
                                            <span>Declare Local Name</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('DeclareLocalName')"></i>
                                        </template>
                                        <el-input v-model="product.declareLocalName"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Package Length(cm)" prop="packageLength">
                                        <template slot="label">
                                            <span>Package Length(cm)</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('PackageLength')"></i>
                                        </template>
                                        <el-input v-model="product.packageLength" type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Package Width(cm)" prop="packageWidth">
                                        <template slot="label">
                                            <span>Package Width(cm)</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('PackageWidth')"></i>
                                        </template>
                                        <el-input v-model="product.packageWidth"  type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Package Height(g)" prop="packageHeight">
                                        <template slot="label">
                                            <span>Package Height(g)</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('PackageHeight')"></i>
                                        </template>
                                        <el-input v-model="product.packageHeight"  type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Custom HS Code" prop="customHsCode">
                                        <template slot="label">
                                            <span>Custom HS Code</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('CustomHSCode')"></i>
                                        </template>
                                        <el-input v-model="product.customHsCode"  type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Weight(g)" prop="weight">
                                        <template slot="label">
                                            <span>Weight(g)</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('Weight')"></i>
                                        </template>
                                        <el-input v-model="product.weight"  type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Package Weight(g)" prop="packageWeight">
                                        <template slot="label">
                                            <span>Package Weight(g)</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('PackageWeight')"></i>
                                        </template>
                                        <el-input v-model="product.packageWeight"  type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Country Of Origin" prop="countryOfOrigin">
                                        <template slot="label">
                                            <span>Country Of Origin</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('CountryOfOrigin')"></i>
                                        </template>
                                        <el-input v-model="product.countryOfOrigin"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Custom Declare Value" prop="customDeclareValue">
                                        <template slot="label">
                                            <span>Custom Declare Value</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('CustomDeclareValue')"></i>
                                        </template>
                                        <el-input type="number" v-model="product.customDeclareValue"></el-input>
                                    </el-form-item>
                                    <el-form-item label=" ">
                                        <el-checkbox border size="big" v-model="product.hasPowder">Powder</el-checkbox>
                                        <el-checkbox border v-model="product.hasLiquid">Liquid</el-checkbox>
                                        <el-checkbox border v-model="product.hasBattery">Battery</el-checkbox>
                                        <el-checkbox border v-model="product.hasReturn">Return</el-checkbox>
                                        <el-checkbox border v-model="product.hasRefund">Refund</el-checkbox>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-footer">
                <div class="btnn active" @click="$router.push('/MaritimeSilkRoad/priceEdit')">
                    上一步
                </div>
                <div class="btnn active" @click="submitProduct">
                    保存
                </div>
            </div>
        </div>
        <div class="foot">
            闽ICP备17025076号-2 <span style="margin: 0 20px"></span>©2017-{{new Date().getFullYear()}} All rights reserved.
        </div>
        <el-dialog
                class="modalInfo"
                title="提示"
                :visible.sync="dialogInfo"
                top="1%"
                width="60%">
            <div slot="title">
                <div class="modalTitle">
                    {{modalData.name}}
                </div>
            </div>
            <div class="modalInfoContent">
                <div class="section" v-for="(item,index) in modalData.content" :key="index">
                    <div class="tit">
                        {{item.title}}
                    </div>
                    <div class="details" v-if="item.content.length>0">
                        <p v-for="(itemm,indexx) in item.content" :key="`${index}_${indexx}`">
                            {{itemm}}
                        </p>
                    </div>
                </div>
                <div class="example" v-if="modalData.example && modalData.example.length>0">
                    <h1>优秀的案例</h1>
                    <p v-for="(item,index) in modalData.example" :key="`e_${index}`">
                        {{item}}
                    </p>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "logisticsEdit",
        data() {
            return {
                dialogInfo:false,
                modalData:{},
                add: {
                    tags: '',
                    keywords: '',
                },
                product: {
                    declareName:'',
                    declareLocalName:'',
                    packageLength:'',
                    packageWidth:'',
                    packageHeight:'',
                    customHsCode:'',
                    weight:'',
                    packageWeight:'',
                    countryOfOrigin:'',
                    customDeclareValue:'',
                    hasPowder:false,
                    hasLiquid:false,
                    hasBattery:false,
                    hasReturn:false,
                    hasRefund:false
                },
                logisticsRules: {
                    declareName:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    declareLocalName:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    packageLength:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    packageWidth:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    packageHeight:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    customHsCode:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    weight:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    packageWeight:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    countryOfOrigin:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    customDeclareValue:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ]
                }
            }
        },
        created() {
            let $product = JSON.parse(JSON.stringify(this.$store.state.template.edit))
            if(!$product.hasPowder) $product.hasPowder=false
            if(!$product.hasLiquid) $product.hasLiquid=false
            if(!$product.hasBattery) $product.hasBattery=false
            if(!$product.hasReturn) $product.hasReturn=false
            if(!$product.hasRefund) $product.hasRefund=false
            Object.assign(this.product,$product)
        },
        computed:{
            productDefault:function () {
                return JSON.parse(JSON.stringify(this.$store.state.template.default))
            }
        },
        watch:{
            product:{
                handler:function (newv) {
                    this.$store.commit('setData',{setKey:'template.edit',value:newv})
                },
                deep:true
            }
        },
        methods: {
            showInfo(v) {
                this.dialogInfo = true
                this.modalData = this.$store.state.productInfo[v]
            },
            submitProduct() {
                this.$refs['logisticsForm'].validate((valid) => {
                    if (valid) {
                        this.axios.post(`/student/product/create`, this.product).then(res => {
                            if (res.succeed) {
                                this.$message.success(res.message);
                                this.$store.commit('setData',{dataKey:'template',template:{default:{}, edit:{}} })
                                this.$router.push('/MaritimeSilkRoad/product')
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    } else {
                        this.$message.error('有必填项未填写，请检查后重试')
                        return false;
                    }
                });

            },
            inputFocus(e) {
                e.target.lastElementChild.focus()
            },
            addItem(name) {
                if (this.add[name].trim() === '') return false;
                this.product[name].push(this.add[name]);
                this.add[name] = '';
            },
            removeItem(item,arrayName) {
                let index = this.product[arrayName].indexOf(item)
                if (index !== -1) {
                    this.product[arrayName].splice(index, 1)
                }
            },
        }
    }
</script>

<style scoped lang="scss">

    .main {
        div.main-content {
            display: flex;

            div.main-left {
                display: flex;
                flex-direction: column;
                margin-right: 28px;
                width: 452px;

                div.product-wrap {
                    background: #FFFFFF;
                    border-radius: 16px;

                    .item {
                        width: 388px;
                        height: 712px;
                        margin: 54px 32px;
                        border: 2px solid #adadad;
                        border-radius: 20px;
                        box-sizing: border-box;
                        padding: 24px;
                        /*background: #f5f5f5;*/
                        display: flex;
                        flex-direction: column;
                        position: relative;

                        > .product-img {
                            width: 100%;
                            height: 0;
                            padding-bottom: 100%;
                            overflow: hidden;
                            position: relative;

                            img {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                max-width: 100%;
                                height: 100%;
                            }
                        }

                        > .product-attached {
                            margin: 12px 0;
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;

                            span {
                                display: inherit;
                                width: 44px;
                                height: 44px;
                                margin-right: 12px;

                                > img {
                                    object-fit: cover;

                                    &:last-child {
                                        margin-right: 0;
                                    }
                                }
                            }
                        }

                        > .product-price {
                            font-size: 34px;
                            margin: 18px 0;
                            color: #E50011;

                        }

                        > .product-title {

                            font-size: 18px;
                            color: #595757;
                            text-overflow: ellipsis;
                            line-height: 20px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            margin-bottom: 18px;
                        }

                        > .product-comments {
                            font-size: 18px;
                            line-height: 20px;
                            color: #adadad;
                            margin: 18px 0;

                            > span {

                                font-weight: bolder;
                                color: #089BAB;
                            }
                        }

                        > .product-shop {
                            span {
                                display: flex;
                                align-items: center;
                                font-size: 18px;
                                line-height: 20px;
                                color: #adadad;

                                i {
                                    margin-left: 8px;
                                    font-size: 28px;
                                    color: #089BAB;
                                }
                            }
                        }

                    }
                }

                div.basics-section {
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    background: #FFFFFF;
                    border-radius: 16px;
                }
            }

            div.main-right {
                display: flex;
                flex-direction: column;
                flex-grow: 2;
            }
        }

    }

    .pagination-wrap {
        display: inline-block;

        > div.pagination {
            padding: 0 20px;
            height: 60px;
            background: #FFFFFF;
            border-radius: 10px;
            box-shadow: 3px 10px 20px -6px #b5cdd3;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
        }
    }

    div.main-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-top: 30px;

        > div.btnn {
            box-shadow: 0px 10px 26px -10px #9E9E9E;
            cursor: pointer;
            background: #FF65A5;
            width: 100%;
            text-align: center;
            padding: 12px ;
            color: #FFFFFF;
            transition: all 0.3s linear;
            &:first-child {
                border-radius: 10px 0 0 10px;
                background: #ABD5DB;
            }

            &:last-child {
                border-radius: 0 10px 10px 0;
                background: #4149A9;
            }
            &:hover {
                transition: all 0.3s ease-in-out;
                box-shadow: 0px 10px 26px -10px #000;
            }
        }
    }

    div.foot {
        width: 100%;
        height: 30px;
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        font-size: 14px;
        color: #ABD5DB;
    }
</style>
